import React, { useEffect, useState } from 'react';
import { FaUniversity, FaUsers, FaGavel, FaRegBuilding } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

import PageHeader from '../../Components/PageHeader/PageHeader';
import ADirectorDesk from '../../Components/ADirectorDesk/ADirectorDesk';
import AAboutUs from '../../Components/AAboutUs/AAboutUs';
import ACoreTeam from '../../Components/ACoreTeam/ACoreTeam';
import ATeamMembers from '../../Components/ATeamMembers/ATeamMembers';
import ABrochure from '../../Components/ABrochure/ABrochure';

import './About.css'

const About = () => {

    const location = useLocation();

    useEffect(() => {
        const pathname = location.pathname;
        let trimmedPathname = pathname;
        if (pathname.endsWith("/")) {
            trimmedPathname = pathname.slice(0, pathname.length - 1); // Remove trailing slash if present
        }
        const segments = trimmedPathname.split("/");
        setActiveId(segments[segments.length - 1])
    }, [location])

    const menuItems = [
        {
            id: 1, title: 'About Us',
            path: 'about',
            icon: <FaUniversity />,
            content: <AAboutUs />
        },
        {
            id: 2, title: 'Director Desk',
            path: 'directorDesk',
            icon: <FaUsers />,
            content: <ADirectorDesk />
        },
        // {
        //     id: 3, title: 'Deputy Team Leader Desk',
        //     path: 'deputyTeamLead',
        //     icon: <FaRegBuilding />,
        //     content: <ADeputyTeamLeaderDesk />
        // },
        {
            id: 4,
            title: 'Core Team',
            path: 'coreTeam',
            icon: <FaGavel />,
            content: <ACoreTeam />
        },
        {
            id: 5,
            title: 'Team Members',
            path: 'teamMember',
            icon: <FaRegBuilding />,
            content: <ATeamMembers />
        },
        // {
        //     id: 6,
        //     title: 'Administrative Staff',
        //     path: 'administrativeStaff',
        //     icon: <FaRegBuilding />,
        //     content: <AAdministrativeStaff />
        // },
        {
            id: 7,
            title: 'Brochure',
            path: 'brochure',
            icon: <FaUniversity />,
            content: <ABrochure />
        },
    ];

    const [activeId, setActiveId] = useState();

    return (
        <>
            <PageHeader
                title="About Us"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    // { label: 'About', href: '/about' },
                    { label: 'About Us' }
                ]}
            />
            <div className="container py-5">

                <div className='row'>
                    {/* Left Menu */}
                    <div className="col-md-3">
                        <div className="border bg-white p-4 shadow-sm rounded h-100">
                            <div className="list-group">
                                <h5 className="fw-bold text-primary mb-4 border-start border-4 ps-2 border-primary">
                                    About
                                </h5>
                                {menuItems.map((item) => (
                                    <button
                                        key={item.id}
                                        className={`list-group-item list-group-item-action d-flex mb-2 justify-content-start ${activeId === item.path ? 'active-menu' : ''}`}
                                        onClick={() => setActiveId(item.path)}
                                    >
                                        <span className="me-2 icon-text">{item.icon}</span> {item.title}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right Content */}
                    <div className="col-md-9">
                        <div className="border bg-white p-4 shadow-sm rounded h-100">
                            <h5 className="fw-bold text-primary mb-4 border-start border-4 ps-2 border-primary">
                                {menuItems.find((item) => item.path === activeId)?.title}
                            </h5>
                            <div className="text-muted">
                                {menuItems.find((item) => item.path === activeId)?.content}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default About;